package org.teddapp.project.db

actual val deviceLabel: String = "Navigateur"
